var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactusTouchMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 27,
    viewBox: "0 0 35 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.375 1H4.125C2.39911 1 1 2.39911 1 4.125V22.875C1 24.6009 2.39911 26 4.125 26H30.375C32.1009 26 33.5 24.6009 33.5 22.875V4.125C33.5 2.39911 32.1009 1 30.375 1Z",
    stroke: "#3F7D20",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99994 6.00002L17.2499 14.75L28.4999 6.00002",
    stroke: "#3F7D20",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactusTouchMailIcon);
export default __webpack_public_path__ + "static/media/contactus_touch_mail_icon.311ec0e9b81cc5587e23357be452eb5d.svg";
export { ForwardRef as ReactComponent };